import { PURPLEZONE_CHARACTER_ID_KEY, PURPLEZONE_SERVER_ID_KEY } from '@constants/common';
import { checkEnvPurpleZone, getSearchParams } from './Utils';

// 퍼플존 팝업의 pzsid, pzcid URL params를 sessionStorage에 설정
export const setPurpleZoneParams = () => {
    if (checkEnvPurpleZone()) {
        const searchParams = getSearchParams(document.location.href);
        if (searchParams) {
            const purplezoneServerId = searchParams[PURPLEZONE_SERVER_ID_KEY];
            if (purplezoneServerId) {
                sessionStorage.setItem(PURPLEZONE_SERVER_ID_KEY, purplezoneServerId);
            }

            const purplezoneCharacterId = searchParams[PURPLEZONE_CHARACTER_ID_KEY];
            if (purplezoneCharacterId) {
                sessionStorage.setItem(PURPLEZONE_CHARACTER_ID_KEY, purplezoneCharacterId);
            }
        }
    }
};
